<template>
  <div id="progreso">
    <router-link
      to="/progreso"
      class="miperfil abs pointer"
      data-aos="fade-right"
      data-aos-delay="200"
    >
      <img
        src="../../../assets/imgs/mision/btn-mi-perfil.png"
        alt="Encauce"
        class="img-fluid w-100"
      />
    </router-link>

    <section class="pantalla">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 contentabs">
            <div
              class="pregunta abs row"
              data-aos="fade-up"
              data-aos-delay="200"
               v-if="resultados != null"
            >
              <div
                class="pregunta_txt abs col-12"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div class="bold row pb3">
                  <div class="col-8">
                    <span class="azulclaro">FORTALEZA </span>
                    <span class="electrico">{{
                      resultados[fortaleza].nombre
                    }}</span>
                  </div>
                  <div class="col-4">
                    <div class="conocemas" @click="toggleInfo">
                      <img
                        class="img-fluid"
                        src="../../../assets/imgs/mision/bg-flecha-siguiente-2.png"
                        alt="Conoce más"
                      />
                    </div>
                    <!-- <div class="texto blanco">
                      <span class="fpG2"> CONOCE MÁS </span>
                    </div> -->
                  </div>
                </div>
                <div class="blanco row">
                  <div class="col-12">
                    La fortaleza determina un tipo de pensamiento especializado
                    con su manera única y exclusiva de percibir el mundo y
                    procesar la información. Identificar tu fortaleza te servirá
                    para conocerte mejor y potenciar las habilidades donde
                    naturalmente eres más eficiente y fluyes mejor.
                  </div>
                </div>
              </div>
            </div>

            <div class="quasar abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/mision/quasar-verde.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div class="logo abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/encauce-logo-blanco-stem.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div
              v-if="resultados != null"
              class="info abs"
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              <div class="row pt3 pb3">
                <div class="col-3">
                  <div class="tarjeta p-0 pt-2 pb-2 bggradazul">
                    <div class="grid fpG1 bold">
                      <div
                        class="w-100 d-flex justify-content-center align-items-center flex-column"
                      >
                        <div class="axiscont w-100 text-center azulclaro">
                          <img
                            class="img-fluid w-100 px-2"
                            src="../../../assets/imgs/mision/cerebro-axis.png"
                            alt="axis"
                          />
                          <div class="axis w-100">
                            <div class="fila">
                              <div class="supizq">
                                <span class="titulo"> Analítico </span>
                                <span
                                  class="cuarto"
                                  :style="{
                                    height: cuartos_circulo.habilidad_2,
                                    width: cuartos_circulo.habilidad_2,
                                  }"
                                ></span>
                              </div>
                              <div class="supder">
                                <span class="titulo"> Creativo </span>
                                <span
                                  class="cuarto"
                                  :style="{
                                    height: cuartos_circulo.habilidad_3,
                                    width: cuartos_circulo.habilidad_3,
                                  }"
                                ></span>
                              </div>
                            </div>
                            <div class="fila">
                              <div class="infizq">
                                <span class="titulo"> Proced. </span>
                                <span
                                  class="cuarto"
                                  :style="{
                                    height: cuartos_circulo.habilidad_0,
                                    width: cuartos_circulo.habilidad_0,
                                  }"
                                ></span>
                              </div>
                              <div class="infder">
                                <span class="titulo"> Empático </span>
                                <span
                                  class="cuarto"
                                  :style="{
                                    height: cuartos_circulo.habilidad_1,
                                    width: cuartos_circulo.habilidad_1,
                                  }"
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="pt-2 electrico fpXXG2 text-center">
                        ACTUAL
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-9 d-flex">
                  <div class="row w-100">
                    <div
                      class="col-12 d-flex justify-content-center align-items-center"
                    >
                      <div class="row w-100 medidores">
                        <div class="col-12">
                          <div class="row pb6">
                            <div class="col-6">
                              <div class="row w-100 no-gutters">
                                <div class="col-7 azulclaro bold fpG">
                                  ANALÍTICO
                                </div>
                                <div class="col-5 electrico fpG">
                                  {{ habilidades.habilidad_2 }} PUNTOS
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12 azuloscuro bold fpG">
                                  <div class="barra">
                                    <span class="analitico"
                                      ><span
                                        :style="{ width: barras.habilidad_2 }"
                                      ></span
                                    ></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="row w-100 no-gutters">
                                <div class="col-7 azulclaro bold fpG">
                                  CREATIVO
                                </div>
                                <div class="col-5 electrico fpG">
                                  {{ habilidades.habilidad_3 }} PUNTOS
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12 azuloscuro bold fpG">
                                  <div class="barra">
                                    <span class="creativo"
                                      ><span
                                        :style="{ width: barras.habilidad_3 }"
                                      ></span
                                    ></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-6">
                              <div class="row w-100 no-gutters">
                                <div class="col-7 azulclaro bold fpG">
                                  PROCEDIMENTAL
                                </div>
                                <div class="col-5 electrico fpG">
                                  {{ habilidades.habilidad_0 }} PUNTOS
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12 azuloscuro bold fpG">
                                  <div class="barra">
                                    <span class="procedimental"
                                      ><span
                                        :style="{ width: barras.habilidad_0 }"
                                      ></span
                                    ></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="row w-100 no-gutters">
                                <div class="col-7 azulclaro bold fpG">
                                  EMPÁTICO
                                </div>
                                <div class="col-5 electrico fpG">
                                  {{ habilidades.habilidad_1 }} PUNTOS
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12 azuloscuro bold fpG">
                                  <div class="barra">
                                    <span class="empatico"
                                      ><span
                                        :style="{ width: barras.habilidad_1 }"
                                      ></span
                                    ></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-if="resultados != null">
                <div class="col-8">
                  <div class="bggradazul tarjeta p-0">
                    <div class="row">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-6">
                            <div class="row">
                              <div
                                class="col-6 d-flex justify-content-center align-items-center"
                              >
                                <div class="fpR">
                                  <span class="azuloscuro bold"
                                    >FORTALEZA:</span
                                  >
                                  <br />
                                  <span
                                    class="azulclaro bold"
                                    v-if="resultados[fortaleza] != null"
                                    >{{ resultados[fortaleza].nombre }}
                                  </span>
                                </div>
                              </div>
                              <div class="col-6 p-0">
                                <div class="bg-cerebro cerebro-fortaleza">
                                  <img
                                    class="img-fluid"
                                    src="../../../assets/imgs/mision/bg-cerebro.png"
                                    alt="cerebro"
                                  />
                                  <img
                                    v-if="
                                      resultados[fortaleza].slug == 'analitico'
                                    "
                                    class="img-fluid over"
                                    src="../../../assets/imgs/mision/perfil-analitico.png"
                                    alt="cerebro"
                                  />
                                  <img
                                    v-if="
                                      resultados[fortaleza].slug == 'creativo'
                                    "
                                    class="img-fluid over"
                                    src="../../../assets/imgs/mision/perfil-creativo.png"
                                    alt="cerebro"
                                  />
                                  <img
                                    v-if="
                                      resultados[fortaleza].slug ==
                                      'procedimental'
                                    "
                                    class="img-fluid over"
                                    src="../../../assets/imgs/mision/perfil-procedimental.png"
                                    alt="cerebro"
                                  />
                                  <img
                                    v-if="
                                      resultados[fortaleza].slug == 'empatico'
                                    "
                                    class="img-fluid over"
                                    src="../../../assets/imgs/mision/perfil-empatico.png"
                                    alt="cerebro"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="row">
                              <div
                                class="col-6 d-flex justify-content-center align-items-center"
                              >
                                <div class="">
                                  <div class="azuloscuro bold fpR pb3">
                                    PERFIL DE COMPETENCIAS:
                                  </div>

                                  <span class="azulclaro bold">
                                    <ul>
                                      <li
                                        class="fpR"
                                        v-for="(item, index) in competencias"
                                        :key="index"
                                      >
                                        {{ resultados[item[0]].nombre }}
                                      </li>
                                    </ul>
                                  </span>
                                </div>
                              </div>
                              <div class="col-6 p-0">
                                <div class="bg-cerebro cerebro-competencias">
                                  <img
                                    class="img-fluid"
                                    src="../../../assets/imgs/mision/bg-cerebro.png"
                                    alt="cerebro"
                                  />
                                  <img
                                    v-if="
                                      competenciasObj['habilidad_2'] != null
                                    "
                                    class="img-fluid over"
                                    src="../../../assets/imgs/mision/perfil-analitico.png"
                                    alt="cerebro"
                                  />
                                  <img
                                    v-if="
                                      competenciasObj['habilidad_3'] != null
                                    "
                                    class="img-fluid over"
                                    src="../../../assets/imgs/mision/perfil-creativo.png"
                                    alt="cerebro"
                                  />
                                  <img
                                    v-if="
                                      competenciasObj['habilidad_0'] != null
                                    "
                                    class="img-fluid over"
                                    src="../../../assets/imgs/mision/perfil-procedimental.png"
                                    alt="cerebro"
                                  />
                                  <img
                                    v-if="
                                      competenciasObj['habilidad_1'] != null
                                    "
                                    class="img-fluid over"
                                    src="../../../assets/imgs/mision/perfil-empatico.png"
                                    alt="cerebro"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="bggradazul tarjeta" v-if="fortaleza != null">
                    <div class="row">
                      <div class="col-12">
                        <!-- <div class="row pb5">
                          <div class="col-4 offset-4 text-center blanco gadget">
                            <img
                              class="w-100 img-fluid"
                              :src="
                                require('../../../assets/imgs/mision/2/gadgets/' + settings.personaje + '-' +
                                  resultados[fortaleza].slug +
                                  '.png')
                              "
                              :alt="resultado"
                            />
                          </div>
                        </div> -->
                        <div class="row titulo azulclaro text-center">
                          <div class="fpG w-100">
                            HAS OBTENIDO: <br />
                            <span class="bold">{{
                              resultados[fortaleza].gadget
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="resultado_mision abs text-center" v-if="resultado != null" data-aos="zoom-in" data-aos-delay="600">
              <div>
                <span class="electrico fXG bold"> ¡Eres</span> <span class="electrico fXG bold">{{resultados[resultado].nombre}}</span> <span class="electrico fXG bold">!</span>
              </div>
            </div> -->

            <div class="cont-btn-sig btn-avanzar col-12 pt5">
              <button @click="avanzar" class="btn-sig float-right">
                <span class="texto">
                  <span class="bold">CONTINUAR</span>
                </span>
                <img
                  class="icono"
                  src="../../../assets/imgs/mision/cohete.png"
                  alt="icono"
                />
                <span class="flecha">
                  <img
                    src="../../../assets/imgs/mision/flecha-sig3.png"
                    alt="icono"
                  />
                </span>
              </button>
              <div class="flecha2">
                <img
                  src="../../../assets/imgs/mision/flecha-sig2.png"
                  alt="icono"
                />
              </div>
              <div class="flecha1">
                <img
                  src="../../../assets/imgs/mision/flecha-sig1.png"
                  alt="icono"
                />
              </div>
            </div>

            <div
              class="personaje abs"
              data-aos="fade"
              data-aos-delay="800"
              v-if="settings.personaje != null"
            >
              <img
                :src="
                  require('../../../assets/imgs/avatar/' +
                    settings.personaje +
                    '.png')
                "
                alt="Encauce"
                class="img-fluid"
              />
              <img
                src="../../../assets/imgs/progreso/brillo-amarillo.png"
                alt="Encauce"
                class="img-fluid brillo"
              />

              <div
                class="gadget"
                :class="avance.misiones[0].resultado_evaluacion"
              >
                <img
                  class="w-100 gadget1"
                  :src="
                    require('../../../assets/imgs/mision/1/gadgets/' +
                      settings.personaje +
                      '-' +
                      avance.misiones[0].resultado_evaluacion +
                      '.png')
                  "
                  :alt="resultado"
                />
              </div>

              <div class="gadget2">
                <img
                  class="w-100"
                  :src="
                    require('../../../assets/imgs/mision/2/gadgets/' +
                      settings.personaje +
                      '-' +
                      resultados[avance.misiones[1].fortaleza].slug +
                      '.png')
                  "
                  :alt="resultado"
                />
              </div>
              <!-- <div v-if="">

              </div> -->
            </div>

            <div class="overlayinfo bggradazulmorado" v-show="displayInfo">
              <div class="bgoverlay" @click="toggleInfo"></div>
              <div class="overlay container" v-if="resultados != null">
                <div class="closeoverlay" @click="toggleInfo">
                  <img
                    class="img-fluid"
                    src="../../../assets/imgs/mision/btn-cerrar-overlay.png"
                    alt="cerrar"
                  />
                </div>
                <div class="contenido row bggradmorado rounded pt5 px5 pb5">
                  <div class="col-8">
                    <div class="fpXXXG bold azulclaro pb5">
                      {{ resultados[fortaleza].nombre }}
                    </div>
                    <div class="blanco fpG1">
                      {{ resultados[fortaleza].detalle }}
                    </div>
                  </div>
                  <div class="col-4">
                    <img
                      class="img-fluid"
                      src="../../../assets/imgs/mision/foco.png"
                      alt="resultado"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import AOS from "aos";
import { mapState } from "vuex";
import swal from "sweetalert2";
import router from "../../../router/index";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      maya_outfit: -1,
      condicion: false,
      settings: {
        personaje: null,
        mision: 1,
      },
      mision: 2,
      avance: [],
      resultado: null,
      habilidades: {
        habilidad_0: null,
        habilidad_1: null,
        habilidad_2: null,
        habilidad_3: null,
      },
      displayInfo: false,
      barras: {
        habilidad_0: "0%",
        habilidad_1: "0%",
        habilidad_2: "0%",
        habilidad_3: "0%",
      },
      cuartos_circulo: {
        habilidad_0: "0vw",
        habilidad_1: "0vw",
        habilidad_2: "0vw",
        habilidad_3: "0vw",
      },

      resultados: null,
      fortaleza: null,
      competencias: null,
      competenciasObj: {},
      initiated: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "institucionID"]),
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      console.log("cambio de ruta");
      this.initiated = false;
      this.init();
    },
    userProfile(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.init();
  },
  methods: {
    async init() {


      if (this.userProfile == null || this.initiated == true) {
        return;
      }

      console.log("iniciando resultados mision 2");

      this.initiated = true;


      await this.getAvance();

      this.resultados = this.$store.state.estilo_de_pensamiento;

      this.avatar = this.avance.avatar;
      if (this.avatar != null) {
        this.settings.personaje =
          this.avatar.slug_personaje + "-" + this.avatar.id_outfit;
      }
      console.log(this.settings.personaje);

      
    },
    async getAvance() {
      let vm = this;
      this.avance = await this.$store.dispatch("getAvance");
      console.log({ avance: this.avance });
      console.log({ mision: this.mision - 1 });
      console.log(this.avance.misiones[this.mision - 1]);
      this.resultado = this.avance.misiones[this.mision - 1];

      this.fortaleza = this.resultado.fortaleza;
      this.competencias = this.resultado.competencias;

      this.habilidades = this.avance.misiones[this.mision - 1].habilidades;
      console.log({ habilidades: this.habilidades.habilidad_0 });
      console.log({ competencias: this.competencias });
      console.log(this.competencias[0][1]);

      this.competenciasObj = {};

      for (var i = 0; i < 4; i++) {
        if (this.competencias[i] != null) {
          console.log({ hey: this.competencias[i][0] });
          this.competenciasObj[this.competencias[i][0]] = this.competencias[
            i
          ][1];
        }
      }

      console.log({ competenciasObj: this.competenciasObj });

      setTimeout(function () {
        vm.calculaBarras();
      }, 1500);
    },
    calculaBarras() {
      let maximo = this.competencias[0][1];
      console.log({ maximo: maximo });
      let multiplicador = 200;
      let total =
        this.habilidades.habilidad_0 +
        this.habilidades.habilidad_1 +
        this.habilidades.habilidad_2 +
        this.habilidades.habilidad_3;

      this.barras.habilidad_0 = (this.habilidades.habilidad_0 * 100) / maximo;
      this.barras.habilidad_1 = (this.habilidades.habilidad_1 * 100) / maximo;
      this.barras.habilidad_2 = (this.habilidades.habilidad_2 * 100) / maximo;
      this.barras.habilidad_3 = (this.habilidades.habilidad_3 * 100) / maximo;

      //
      this.cuartos_circulo.habilidad_0 =
        (this.barras.habilidad_0 / 100) * 7 + "vw";
      this.cuartos_circulo.habilidad_1 =
        (this.barras.habilidad_1 / 100) * 7 + "vw";
      this.cuartos_circulo.habilidad_2 =
        (this.barras.habilidad_2 / 100) * 7 + "vw";
      this.cuartos_circulo.habilidad_3 =
        (this.barras.habilidad_3 / 100) * 7 + "vw";

      console.log({ cuartos: this.cuartos_circulo });

      this.barras.habilidad_0 = this.barras.habilidad_0 + "%";
      this.barras.habilidad_1 = this.barras.habilidad_1 + "%";
      this.barras.habilidad_2 = this.barras.habilidad_2 + "%";
      this.barras.habilidad_3 = this.barras.habilidad_3 + "%";
    },
    selecciona(mision) {
      router.push("/mision-" + mision + "-intro");
    },
    avanzar() {
      //router.push("/mision-" + this.mision + "-cuestionario");
      router.push("/mision-3-intro");
      //this.$router.push("/resultados/descarga");
    },
    toggleInfo() {
      this.displayInfo = !this.displayInfo;
    },
  },
};
</script>

<style lang="scss" scoped>
$amarillo: #ffcc00;
#progreso {
  background: url(../../../assets/imgs/resultados/bg-resultados.jpg) no-repeat;
  background-size: cover;
  background-position: bottom right;
  .contentabs {
    .logo {
      bottom: 5%;
      left: 5%;
      width: 20%;
      position: absolute;
    }
    .centradoxy {
      position: absolute;
      top: 50%;
      transform: translateY(-50%) translateX(-50%);
      width: 80%;
      left: 50%;
    }
    .personaje {
      bottom: 4%;
      right: 4%;
      width: 20%;
      position: absolute;
      img {
        width: 100%;
      }
      .brillo {
        position: absolute;
        bottom: 0;
        left: 0;
        opacity: 0.5;
        animation: titilar 2s infinite;
      }
      .gadget {
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        img {
          width: 100%;
        }
        /*&.acomodador {
          top: 37%;
          width: 37.4%;
          left: 23%;
        }
        &.asimilador {
          top: 4%;
          width: 28.4%;
          left: 25%;
        }
        &.convergente {
          top: -0.5%;
          width: 33.4%;
          left: 22%;
        }
        &.divergente {
          top: 37%;
          width: 66.4%;
          left: 9%;
        }*/
      }
      .gadget2 {
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        img {
          width: 100%;
        }
      }
    }

    .pregunta {
      top: 10%;
      left: 8%;
      width: 82%;
      position: absolute;
      .pregunta_txt {
        top: 50%;
        transform: translateY(-50%);
        left: 0%;
        width: 70%;
        margin: 0 0 0 20%;
        position: absolute;
        div {
          font-size: 1.2vw;
        }
        .conocemas {
          cursor: pointer;
          position: absolute;
          width: 15vw;
          left: 0%;
          top: 0%;
          img {
            width: 100%;
          }
          .texto {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            display: flex;
            align-items: center;
            user-select: none;
            span {
              position: relative;
              top: 0.4vw;
              left: 2.2vw;
            }
          }
        }
      }
    }
    .quasar {
      top: 4.3%;
      left: 13%;
      width: 7%;
      position: absolute;
      animation: float 6s ease-in-out infinite;
      z-index: 100;
    }

    .info {
      width: 75%;
      top: 20%;
      left: 3%;
    }
    .resultado_mision {
      width: 70%;
      top: 25%;
      left: 3%;
      img {
        width: auto !important;
      }
    }

    .botonera {
      width: 40%;
      top: 13%;
      left: 54%;
      .bgtitulo {
        width: 80%;
        margin: 0 10%;
        position: relative;
        .texto {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 100%;
          left: 0px;
        }
      }
      .mision {
        width: 33.33%;
        position: relative;
        .planeta {
          position: absolute;
          left: 0;
          top: 12%;
          width: 70%;
          margin: 0 15%;
        }
        .planeta-lock {
          position: absolute;
          left: 0;
          top: 12%;
          width: 70%;
          margin: 0 15%;
        }
      }
    }

    .btn-avanzar {
      position: absolute;
      bottom: 6%;
      right: 0%;
      z-index: 1000;
    }

    @media (min-width: 993px) {
      .personaje {
        bottom: 4%;
        right: 0%;
        width: 23%;
      }
    }
  }

  .tarjeta {
    width: 100%;
    border: 2px solid #0662ca;
    padding: 1vw 2vw;
    .grid {
      .barra {
        height: 1vw;
        width: 0%;
        -webkit-border-top-right-radius: 2vw;
        -webkit-border-bottom-right-radius: 2vw;
        -moz-border-radius-topright: 2vw;
        -moz-border-radius-bottomright: 2vw;
        border-top-right-radius: 2vw;
        border-bottom-right-radius: 2vw;
        transition: 0.5s all ease-out;
      }
    }

    .gadget {
      img {
        width: 100% !important;
      }
    }
  }
}

.axiscont {
  position: relative;
  .axis {
    position: absolute;
    top: 0px;
    bottom: 0px;
    height: 100%;
    .fila {
      width: 100%;
      height: 50%;
      display: flex;
      flex-direction: row;
      > div {
        position: relative;
        width: 100%;
        display: flex;
        justify-content: center;
        align-content: center;
        text-align: center;
        span {
          width: 100%;
          display: block;
          font-size: 1.2vw;
        }
        &.supizq {
          position: relative;
          .cuarto {
            position: absolute;
            right: 0px;
            bottom: 0px;
            width: 0vw;
            height: 0vw;
            background: rgba(18, 138, 229, 0.6);
            border-radius: 7vw 0 0 0;
            -moz-border-radius: 7vw 0 0 0;
            -webkit-border-radius: 7vw 0 0 0;
            transition: 2s all ease-out;
          }
        }
        &.supder {
          position: relative;
          .cuarto {
            content: " ";
            position: absolute;
            bottom: 0px;
            left: 0px;
            width: 7vw;
            height: 7vw;
            background: rgba(18, 138, 229, 0.6);
            border-radius: 0 7vw 0 0;
            -moz-border-radius: 0 7vw 0 0;
            -webkit-border-radius: 0 7vw 0 0;
            transition: 2s all ease-out;
          }
        }
        &.infizq {
          position: relative;
          .cuarto {
            content: " ";
            position: absolute;
            top: 0;
            right: 0px;
            width: 7vw;
            height: 7vw;
            background: rgba(18, 138, 229, 0.6);
            border-radius: 0 0 0 7vw;
            -moz-border-radius: 0 0 0 7vw;
            -webkit-border-radius: 0 0 0 7vw;
            transition: 2s all ease-out;
          }
        }
        &.infder {
          position: relative;
          .cuarto {
            content: " ";
            position: absolute;
            top: 0;
            left: 0px;
            width: 7vw;
            height: 7vw;
            background: rgba(18, 138, 229, 0.6);
            border-radius: 0 0 7vw 0;
            -moz-border-radius: 0 0 7vw 0;
            -webkit-border-radius: 0 0 7vw 0;
            transition: 2s all ease-out;
          }
        }
      }
      &:nth-child(2) {
        span.titulo {
          position: absolute;
          bottom: 0.5vw;
          left: 0px;
        }
      }
    }
  }
}

.overlayinfo {
  position: fixed;
  top: 0px;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  .bgoverlay {
    position: fixed;
    top: 0px;
    left: 0;
    bottom: 0;
    right: 0;
  }
  .overlay {
    position: relative;
    .closeoverlay {
      z-index: 10000;
      position: absolute;
      top: -5vw;
      right: -5vw;
      cursor: pointer;
      img {
        width: 10vw;
      }
    }
  }
}

.bg-cerebro {
  img.over {
    position: absolute;
    top: 0;
    left: 0;
  }
}

.medidores {
  .barra {
    margin-top: 0.8vw;
    width: 100%;

    > span {
      height: 2.8vw;
      width: 100%;
      background: #197ea7;
      display: flex;
      align-items: center;
      border-radius: 3vw;
      box-shadow: 0px 0px 15px #33ccfd;
      border: 2px solid #33ccfd;
      position: relative;
      padding: 0 0.6vw;
      > span {
        height: 0.3vw;
        width: 100%;
        border-radius: 3vw;
        background: white;
        box-shadow: 0px 0px 10px #fff;
        transition: 2s all ease-out;
      }
    }
    > span.creativo {
      background: #cd3b7d;
      border: 2px solid #e354ae;
      box-shadow: 0px 0px 15px #e354ae;
      > span {
        border-radius: 3vw;
        box-shadow: 0px 0px 10px #fff;
      }
    }
    > span.procedimental {
      background: #0b8423;
      border: 2px solid #06c54a;
      box-shadow: 0px 0px 15px #06c54a;
      > span {
        border-radius: 3vw;
        box-shadow: 0px 0px 10px #fff;
      }
    }
    > span.empatico {
      background: #e45d06;
      border: 2px solid #fe4700;
      box-shadow: 0px 0px 15px #fe4700;
      > span {
        border-radius: 3vw;
        box-shadow: 0px 0px 10px #fff;
      }
    }
  }
}
</style>
